import { InjectionToken, NgModule } from '@angular/core';
import { CrmDependencies, CrmInjectionToken } from './tokens-and-interfaces';

@NgModule({
  imports: [],
})
export class CrmCoreModule {
  static forRoot(config: InjectionToken<CrmDependencies>) {
    return {
      ngModule: CrmCoreModule,
      providers: [
        {
          provide: CrmInjectionToken,
          useExisting: config,
          deps: [],
        },
      ],
    };
  }
}
